import React from 'react';
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';

const SalesFilters = ({ filter, onFilterChange }) => {

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      onFilterChange(newFilter);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, p: 2, backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: 1 }}>
      <Typography variant="h6" sx={{ fontFamily: 'Cinzel, serif' }}>
        Sprzedaże
      </Typography>
      <ToggleButtonGroup
        value={filter}
        exclusive
        onChange={handleFilterChange}
        aria-label="Filtr sprzedaży"
      >
        <ToggleButton value="all" aria-label="wszystkie">Wszystkie</ToggleButton>
        <ToggleButton value="in_progress" aria-label="w trakcie">W trakcie</ToggleButton>
        <ToggleButton value="completed" aria-label="zakończone">Zakończone</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SalesFilters;
